// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"9389e7a1","419":"f915382f","459":"072f432b","505":"eb2f3d0e","774":"f9bc3108","787":"9d8f31fe","813":"23b32a20","858":"5ed0043a"}[chunkId] + ".chunk.js";
};